import { Dispatch } from 'react';
import { ClientPersistedState } from './clientpersistedstate-types';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks/ReduxHooks';
import { setClientPersistedState } from './actions';

export function useClientPersistedState<PropertyType extends keyof ClientPersistedState>(
  propertyName: PropertyType,
  dynamicDefault?: ClientPersistedState[PropertyType]
): [ClientPersistedState[PropertyType], Dispatch<ClientPersistedState[PropertyType]>] {
  const dispatch = useDispatch();
  const propertyValue = useAppSelector<ClientPersistedState[PropertyType]>((state) => state.clientPersistedState?.[propertyName]) ?? dynamicDefault;

  const set = (value: ClientPersistedState[PropertyType]) => {
    dispatch(setClientPersistedState({ [propertyName]: value }));
  };

  return [propertyValue, set];
}
